import React from 'react';
import { css } from 'aphrodite/no-important';

import style from './style';

const Callout = ({ intro, title1, title2, paragraph1, paragraph2 }) => (
  <div className={ css(style.container) }>

    <div className={ css(style.introP) }>
      <h2 className={ css(style.intro) }>{intro}</h2>
    </div>

    <div className={ css(style.columns) } >

      <div className={ css(style.paragraphColumns) }>
        <h3 className={ css(style.titles) }>{title1} </h3>
        <h4 className={ css(style.paragraphs) }>{paragraph1}</h4>
      </div>

      <div className={ css(style.paragraphColumns) }>
        <h3 className={ css(style.titles) }>{title2} </h3>
        <h4 className={ css(style.paragraphs) }>{paragraph2}</h4>
      </div>
      
    </div>

  </div>
);


Callout.propTypes = {
  intro: React.PropTypes.string.isRequired,
  title1: React.PropTypes.string.isRequired,
  paragraph1: React.PropTypes.string.isRequired,
  title2: React.PropTypes.string.isRequired,
  paragraph2: React.PropTypes.string.isRequired,
};

export default Callout;



// WEBPACK FOOTER //
// ./src/components/Callout/index.js